export default "__VITE_ASSET__6RJjQ$n5__"